import React from "react";
import { Avatar, AvatarProps } from "./Avatar";
import { useTopic } from "--client/common/data/PeopleHooks";
import { AvatarSizeName } from "--components/theme";
import styled from "styled-components";
import { useCurrentWorkspace, useLoggedInUser } from "--client/common/hooks/useLoggedInUser";
import AvatarFromID from "./AvatarFromID";

type SpaceAvatarFromIDProps = {
    space_id: string
    size?: AvatarSizeName
    disabled?: boolean
    withHeader?: boolean
    hideStatus?: boolean
} & AvatarProps

const StyledUserspaceAvatar = styled.div`
    position:relative;
`

const UserspaceAvatar: React.FC = props => {
    return <StyledUserspaceAvatar>
        <div style={{ color: "red", position: "absolute", left: 0, top: 0, height: "25%", width: "25%" }} />
    </StyledUserspaceAvatar>
}
const StyledOrgHeader = styled.div`
    ${p => p.theme.typography.body3}
    font-weight: ${p => p.theme.typography.bold};

    position: relative;
    z-index: 1;
    margin: 0 0 -1px 0;
    background-color: ${p => p.theme.palette.text.primary};
    color: ${p => p.theme.palette.text.contrast};
    text-align: center;
    border-radius:  max(${p => p.theme.radius.small}, 5%) max(${p => p.theme.radius.small}, 5%) 0px 0px;
`
const SpaceAvatarFromID = React.forwardRef((props: SpaceAvatarFromIDProps, ref: React.Ref<HTMLDivElement>) => {
    const { space_id, size, disabled, hideStatus, ...rest } = props;
    const topic = useTopic(space_id);
    const user = useLoggedInUser();
    const currentWorkspace = useCurrentWorkspace();
    const assetId = topic?.avatar_asset_id;
    const initials = space_id === "self" ? "DM" : topic ? topic.name.substring(0, 1) : undefined;
    const amSpaceDMMember = topic?.type.name === "stream" && topic.type.subtype === "spaceDM" && !!topic.type.people.find(v => v === user.user_or_identity_id) || false;
    const spaceDMMemberID = !amSpaceDMMember && topic?.type.name === "stream" && topic.type.subtype === "spaceDM" && topic.type.people.at(0) || false
    if (space_id !== "error" && space_id !== "self" && (topic?.type.name === "space" || topic?.type.name === "stream") && topic.type.userspace_id !== currentWorkspace)
        return <SpaceAvatarFromID space_id={topic.type.userspace_id} ref={ref} />

    return <>{props.withHeader && topic?.type.name === "org" ? <StyledOrgHeader>ORG</StyledOrgHeader> : null} {
        amSpaceDMMember || !(topic?.type.name === "stream" && topic.type.subtype === "spaceDM")
            ? <Avatar
                ref={ref}
                size={size}
                colorSeed={props.space_id}
                disabled={disabled}
                displayName={topic?.name}
                initials={initials}
                avatar_asset_id={assetId}
                {...rest}
                square={props.withHeader && topic?.type.name === "org" ? "half" : true}
            >
                {topic?.type.name === "org" ? <UserspaceAvatar /> : undefined}
            </Avatar>
            : <AvatarFromID userId={spaceDMMemberID || user.user_or_identity_id} disabled={disabled} hideStatus={hideStatus} size={size} {...rest} />}
    </>
});


export { SpaceAvatarFromID, SpaceAvatarFromIDProps };